import {getReportParams, report} from 'app/middleware/report';

export function dwhCannotReplaceSim(customerName, subscriber, idNumber, ban) {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'SIMtoNewSim';
    reportParams.actionType = 'Check To Start The Process';
    reportParams.status = 'Service Needed';
    reportParams.messageText = 'NO Entered Service Page';
    reportParams.subscriber = subscriber;
    reportParams.idNumber = idNumber;
    reportParams.customerName = customerName;
    reportParams.banId = ban;
    
    report(reportParams);
}

export function dwhCannotReplaceSimFinancial(customerName, subscriber, idNumber, ban) {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'SIMtoNewSim';
    reportParams.actionType = 'Check To Start The Process';
    reportParams.status = 'Service Needed';
    reportParams.messageText = 'NO Entered Service Page Financial';
    reportParams.subscriber = subscriber;
    reportParams.idNumber = idNumber;
    reportParams.customerName = customerName;
    reportParams.banId = ban;

    report(reportParams);
}

export function dwhDisplaySimNumberInputPage(customerName, subscriber, idNumber, ban) {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'SIMtoNewSim';
    reportParams.actionType = 'SIM Update Page';
    reportParams.status = 'Ongoing';
    reportParams.messageText = 'Update Page Displayed';
    reportParams.subscriber = subscriber;
    reportParams.idNumber = idNumber;
    reportParams.customerName = customerName;
    reportParams.banId = ban;

    report(reportParams);
}

export function dwhContinueButton(newSimNumber, customerName, subscriber, idNumber, ban) {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'SIMtoNewSim';
    reportParams.actionType = 'SIM Update Page';
    reportParams.status = 'Ongoing';
    reportParams.messageText = 'Update Page Button Clicked';
    reportParams.subscriber = subscriber;
    reportParams.idNumber = idNumber;
    reportParams.customerName = customerName;
    reportParams.param1 = newSimNumber;
    reportParams.banId = ban;


    report(reportParams);
}

export function dwhDisplayConfirmationPopUp(newSimNumber, customerName, subscriber, idNumber, ban) {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'SIMtoNewSim';
    reportParams.actionType = 'WarningPopup';
    reportParams.status = 'Ongoing';
    reportParams.messageText = 'Warning Popup Displayed';
    reportParams.subscriber = subscriber;
    reportParams.idNumber = idNumber;
    reportParams.customerName = customerName;
    reportParams.param1 = newSimNumber;
    reportParams.banId = ban;

    report(reportParams);
}

export function dwhConfirmSimReplacementButton(newSimNumber, customerName, subscriber, idNumber, ban) {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'SIMtoNewSim';
    reportParams.actionType = 'WarningPopup';
    reportParams.status = 'Ongoing';
    reportParams.messageText = 'Warning Popup Button Clicked';
    reportParams.subscriber = subscriber;
    reportParams.idNumber = idNumber;
    reportParams.customerName = customerName;
    reportParams.param1 = newSimNumber;
    reportParams.banId = ban;

    report(reportParams);
}

export function dwhGeneralError(newSimNumber, customerName, subscriber, idNumber, ban) {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'SIMtoNewSim';
    reportParams.actionType = 'Update SIM';
    reportParams.status = 'Error';
    reportParams.messageText = 'General Error';
    reportParams.subscriber = subscriber;
    reportParams.idNumber = idNumber;
    reportParams.customerName = customerName;
    reportParams.param1 = newSimNumber;
    reportParams.banId = ban;

    report(reportParams);
}


export function dwhSuccess(newSimNumber, customerName, subscriber, idNumber, ban) {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'SIMtoNewSim';
    reportParams.actionType = 'Update SIM';
    reportParams.status = 'Completed';
    reportParams.messageText = 'Success';
    reportParams.subscriber = subscriber;
    reportParams.idNumber = idNumber;
    reportParams.customerName = customerName;
    reportParams.param1 = newSimNumber;
    reportParams.banId = ban;

    report(reportParams);
}
